import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Image from 'components/Image';
import iconNo from 'images/icon_no.svg';
import iconYes from 'images/icon_yes.svg';
import FormControl from '@material-ui/core/FormControl';
import styles from './index.module.css';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles(() => ({
  formControl: {
    display: 'flex',
    marginBottom: '1rem',
    flexDirection: 'row',
  },
  image: {
    marginLeft: '1rem',
  },
}));

const Boolean = ({
  value,
  className,
  fieldSelection,
  required,
  error,
  label,
}) => {
  const classes = useStyles();

  const display = fieldSelection => {
    if (fieldSelection) {
      return (
        <FormControl
          className={cn(classes.formControl, className)}
          required={required}
          error={error}
        >
          <InputLabel>{label}</InputLabel>
          <div className={classes.image}>
            <Image
              className={cn(styles.img, className)}
              src={value ? iconYes : iconNo}
            />
          </div>
        </FormControl>
      );
    } else {
      return (
        <Image
          className={cn(styles.img, className)}
          src={value ? iconYes : iconNo}
        />
      );
    }
  };
  return display(fieldSelection);
};

Boolean.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Boolean;
